import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const EmergencyContacts = Loadable({
  loader: () => import("./components/emergency-contacts"),
  loading: Loading
});
export const routes = [
  {
    path: '/emergency-contacts',
    exact: true,
    name: 'Emergency Contacts',
    component: EmergencyContacts,
  }
];